export default "__VITE_ASSET__4678901b__"